
import {
  defineComponent,
} from 'vue';

import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import ServicoPlanoAssinatura from '@/servicos/PainelAdministrativo/ServicoPlanoAssinatura';
import PlanoAssinaturaModal from './PlanoAssinaturaModal.vue';

export default defineComponent({
  name: 'PlanoAssinatura',
  components: {
    TelaPadraoCrud,
    PlanoAssinaturaModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoPlanoAssinatura = new ServicoPlanoAssinatura();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = false;
    crudBase.estrutura.verificarCadastroCompartilhado = false;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do plano';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Nome', dataIndex: 'nome', key: 'NomePlanoAssinatura', position: 0, visible: true, ordering: true, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Identificador', dataIndex: 'identificador', key: 'IndentificadorPlanoAssinatura', position: 0, visible: true, ordering: false, align: 'left',
      },
      {
        title: 'Código', dataIndex: 'codigo', key: 'CodigoPlanoAssinatura', position: 1, visible: false,
      },
      {
        title: 'Ações', key: 'acoes', position: 5, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'CodigoPlanoAssinatura', ordem: 'DESC' } as IOrdenacao);

    return {
      crudBase,
      servicoPlanoAssinatura,
      exibirModal,
      sincronizaTelaCrud,
    };
  },
});
